<template>
  <router-link :to="passedTo"><slot></slot></router-link>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    to: Object,
  },
  computed: {
    ...mapState(["home"]),
    passedTo() {
      let $route = this.$router.options.routes.find((route) => {
        return route.name == this.to.name;
      });
      if ($route.meta && $route.meta.userRoute) {
        return this.to;
      }

      let passedTo = this.to;
      if (!passedTo.params) {
        passedTo.params = {
          homeSlug: this.home.slug ?? 'vff',
        };
      } else {
        passedTo.params.homeSlug = this.home.slug ?? 'vff';
      }

      return passedTo;
    },
  },
};
</script>

<style lang="scss" scoped></style>
